export default function createServiceProfile({ next, store }) {
  const status = store.getters['auth/getRole']
  if (status === 'Guest' || status === 'Super-admin' || status === 'Employee') {
    return next()
  }
  return next({ name: 'misc-not-authorized' })
}
